import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import PurchaseTerms from "@/pages/legal/PurchaseTerms";
import Cookies from "@/pages/legal/Cookies";
import Contact from "@/pages/legal/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/integritetspolicy" element={<Privacy />} />
          <Route path="/anvandarvillkor" element={<Terms />} />
          <Route path="/kopvillkor" element={<PurchaseTerms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
